export const openRouteOnNewTab = (
  router,
  routeName,
  routeArgs = {},
) => {
  if (!router || !routeName) {
    return;
  }

  const resolvedRoute = router.resolve({ ...routeArgs, name: routeName });

  window.open(resolvedRoute.href, '_blank');
}
